import React, { useEffect, useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomerTypeById, getCustomerTypeById, saveCustomerType, updateCustomerType } from "../../../actions/CustomerTypeActions";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { getInsuranceTypeById, updateInsuranceType } from "../../../actions/InsuranceTypeActions";
import { getClientById, updateClient } from "../../../actions/ClientActions";
import { getStateById, updateState } from "../../../actions/StateAction";
import { getColorById, updateColor } from "../../../actions/ColorActions";
import Toast from "../../../components/Toast";
import Mobilemenu from "../../../layouts/mobile-menu";
function EditColor() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [name, setName] = useState('');

    useEffect(() => {
        dispatch(getColorById(params.id));
    }, [])

    const color = useSelector(state => state?.color?.color);

    

    useEffect(() => {
        if (Object.keys(color).length > 0) {
            setName(color.name);
        }
    }, [color])

    const save = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
            }
            await dispatch(updateColor(data, params.id));
        }
        // // window.location.href = ('/color')
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Edit Color
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12 g-col-lg-6">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div>
                                    <label for="crud-form-1" className="form-label">Name</label>
                                    <input id="crud-form-1" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Name..." />
                                </div>
                                {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/color')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button type="button" onClick={save} className="btn btn-primary w-24">Update</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditColor;